module.exports = __webpack_public_path__ + "images/communityCare_d8acec8.png";